import React from "react";
import {withStyles} from "material-ui/styles/index";
import styles from "./styles";
import { Button, Cell, Column, Heading, Row, TableBody, TableHeader, TableView } from "@adobe/react-spectrum";
import history from "../../../history";
import CreateProfileModal from "../create-profile-modal";
import CloneProfileModal from "../clone-profile-modal";
import DeleteConfirmModal from "../delete-confirm-modal";

class SmartFlagsProfileList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isCreateModalOpen: false,
      isCloneModalOpen: false,
      cloneSourceProfile: null,
      showConfirmDelete: false,
      deleteProfileId: null,
    };
  }

  openCreateEditor() {
    this.props.resetSmartFlagProfileDetail();
    this.setState({
      isCreateModalOpen: true,
    });
  }

  openEditEditor(profileId) {
    history.push(`/smartflags/${profileId}`);
  }

  openCloneModal(profileId) {
    const { profiles } = this.props;
    const profile = profiles.find(p => p.id === profileId);
    this.setState({
      isCloneModalOpen: true,
      cloneSourceProfile: profile,
    });
  }

  closeCloneModal() {
    this.setState({
      isCloneModalOpen: false,
      cloneSourceProfile: null,
    });
  }

  closeCreateModal() {
    this.props.resetSmartFlagProfileDetail();
    this.setState({
      isCreateModalOpen: false,
    });
  }

  createProfile(data) {
    const createData = {...data};
    return this.props.createSmartFlagProfile(createData).then(() => {
      this.closeCreateModal();
      this.props.refreshProfiles();
    });
  }

  handleClone(sourceProfileId, newName) {
    return this.props.cloneSmartFlagProfile(sourceProfileId, newName).then(() => {
      this.props.refreshProfiles();
    });
  }

  handleSetDefault(profileId) {
    const {organisationId} = this.props;
    this.props.setSmartFlagProfileDefault(profileId, organisationId, true).then(() => {
      this.props.refreshProfiles();
    });
  }

  handleRemoveDefault(profileId) {
    const {organisationId} = this.props;
    this.props.setSmartFlagProfileDefault(profileId, organisationId, false).then(() => {
      this.props.refreshProfiles();
    });
  }

  confirmDelete(profileId) {
    this.setState({
      showConfirmDelete: true,
      deleteProfileId: profileId,
    });
  }

  cancelDelete() {
    this.setState({
      showConfirmDelete: false,
      deleteProfileId: null,
    });
  }

  executeDelete() {
    const {deleteProfileId} = this.state;
    this.props.deleteSmartFlagProfile(deleteProfileId).then(() => {
      this.cancelDelete();
      this.props.refreshProfiles();
    });
  }

  render() {
    const {classes, translate, profiles, profileDetail, impersonating, softwareUpdate} = this.props;
    const {
      isCreateModalOpen,
      isCloneModalOpen,
      cloneSourceProfile,
      showConfirmDelete,
    } = this.state;

    const extraTopOffset = impersonating && softwareUpdate ? 120 : impersonating || softwareUpdate ? 60 : 0;

    return (
      <div className={classes.root} style={{ paddingTop: 96 + extraTopOffset + 'px' }}>
        <div className={classes.header}>
          <Heading level={1} marginBottom="size-0" marginTop="size-0">
            {translate('smart_flag_profiles_title')}
          </Heading>
          <Button variant="primary" onPress={() => this.openCreateEditor()}>
            {translate('smart_flag_add_profile')}
          </Button>
        </div>

        <p className={classes.introduction}>
          {translate("smart_flag_profiles_intro")}
        </p>

        {profiles && profiles.length > 0 ? (
          <div className={classes.tableContainer}>
            <TableView aria-label={translate('smart_flag_profiles_title')}>
              <TableHeader>
                <Column>{translate('profile_name')}</Column>
                <Column>{translate('smart_flag_profile_flags')}</Column>
                <Column width={380}>{translate('general_actions')}</Column>
              </TableHeader>
              <TableBody items={profiles}>
                {(profile) => (
                  <Row key={profile.id}>
                    <Cell>{profile.name}</Cell>
                    <Cell>{profile.valueCount}</Cell>
                    <Cell>
                      <div className={classes.actions}>
                        <Button
                          variant="secondary"
                          onPress={() => this.openEditEditor(profile.id)}
                        >
                          {translate('general_edit')}
                        </Button>
                        <Button
                          variant="secondary"
                          onPress={() => this.openCloneModal(profile.id)}
                        >
                          {translate('smart_flag_clone_profile')}
                        </Button>
                        <Button
                          variant="negative"
                          onPress={() => this.confirmDelete(profile.id)}
                        >
                          {translate('general_delete')}
                        </Button>
                      </div>
                    </Cell>
                  </Row>
                )}
              </TableBody>
            </TableView>
          </div>
        ) : (
          <div className={classes.emptyState}>
            <p>{translate('smart_flag_profiles_empty')}</p>
          </div>
        )}

        <CreateProfileModal
          isOpen={isCreateModalOpen}
          onClose={() => this.closeCreateModal()}
          onSave={(data) => this.createProfile(data)}
          translate={translate}
        />

        <CloneProfileModal
          isOpen={isCloneModalOpen}
          onClose={() => this.closeCloneModal()}
          onConfirm={(sourceProfileId, newName) => this.handleClone(sourceProfileId, newName)}
          sourceProfile={cloneSourceProfile}
          translate={translate}
        />

        <DeleteConfirmModal
          isOpen={showConfirmDelete}
          onCancel={() => this.cancelDelete()}
          onConfirm={() => this.executeDelete()}
          translate={translate}
        />
      </div>
    );
  }
}

export default withStyles(styles)(SmartFlagsProfileList);
